export default __webpack_public_path__ + "static/media/IT.82a9591f.svg";